export default () => ({
  jobs: [],
  errorsFetchingJobs: [],
  isFetchingJobs: false,
});
